import React, { useEffect, useState } from "react";
import "./addCustomerForm.scss";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { TextField } from "@mui/material";
import AllServices from "../../Services/AllServices";
import { toast } from "react-toastify";
import CustomLoader from "../CustomLoader/CustomLoader";
import { status } from "../../Constants/Constants";
import "@fontsource/roboto";
import "@fontsource/roboto/700.css";
import { useFetchContext } from "../../Context/FetchContext";

const AddCustomerForm = ({
  onClick,
  btnName,
  titleName,
  data,
  mode = "add",
}) => {
  const [generatedLink, setGeneratedLink] = useState("");
  const [linkCard, setLinkCard] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [disableBtn, setDisableBtn] = useState(false);
  const { setShouldFetch } = useFetchContext();
  const [txtDisabled, setTxtDisabled] = useState(true);

  const [form, setForm] = useState({
    Refference_Number: data?.Refference_Number ? data.Refference_Number : "",
    Customer_Fname: data?.Customer_Fname ? data.Customer_Fname : "",
    Customer_Lname: data?.Customer_Lname ? data.Customer_Lname : "",
    Contact_Number: data?.Contact_Number ? data.Contact_Number : "",
    Arriving_DateTime: data?.Arriving_DateTime
      ? dayjs(data.Arriving_DateTime)
      : null,
    Depature_DateTime: data?.Depature_DateTime
      ? dayjs(data.Depature_DateTime)
      : null,
    Num_Of_Adults: data?.Num_Of_Adults ? data.Num_Of_Adults : "",
    Num_Of_Kids: data?.Num_Of_Kids ? data.Num_Of_Kids : "",
    status: data?.Status ? data?.Status : status.pending,
  });

  const validateForm = () => {
    const errors = {};

    if (!form.Refference_Number)
      errors.Refference_Number = "Reference Number is Required";
    if (!form.Customer_Fname) errors.Customer_Fname = "First Name is Required";
    if (!form.Customer_Lname) errors.Customer_Lname = "Last Name is Required";
    if (!form.Contact_Number)
      errors.Contact_Number = "Contact Number is Required";
    if (!form.Arriving_DateTime)
      errors.Arriving_DateTime = "Arriving date is Required";
    if (!form.Depature_DateTime)
      errors.Depature_DateTime = "Depature date is Required";
    if (!form.Num_Of_Adults)
      errors.Num_Of_Adults = "Num of Adults are Required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleDateChange = (newValue, fieldName) => {
    setForm((prev) => ({
      ...prev,
      // [fieldName]: newValue ? newValue.format("YYYY-MM-DD") : null,
      [fieldName]: newValue, // keep dayjs object
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    const dataObj = {
      Refference_Number: form.Refference_Number,
      Customer_Fname: form.Customer_Fname,
      Customer_Lname: form.Customer_Lname,
      Contact_Number: form.Contact_Number,
      Arriving_DateTime: form.Arriving_DateTime,
      Depature_DateTime: form.Depature_DateTime,
      Num_Of_Adults: form.Num_Of_Adults,
      Num_Of_Kids: form.Num_Of_Kids,
      Status: form.status,
      // IsRecord_Accepted: form.IsRecord_Accepted,
      // IsRecord_Accepted: true,
    };

    const payload = {
      ...form,
      Arriving_DateTime: form.Arriving_DateTime
        ? form.Arriving_DateTime.format("YYYY-MM-DD")
        : null,
      Depature_DateTime: form.Depature_DateTime
        ? form.Depature_DateTime.format("YYYY-MM-DD")
        : null,
    };

    try {
      setLoading(true);
      const response =
        mode === "add"
          ? await AllServices.addReferenceDetails(payload)
          : await AllServices.editBookingReference(
              form.Refference_Number,
              payload
            );

      if (response?.data?.succuss) {
        toast.success(response.data.message);
        setDisableBtn(true);
        onClick();
        setShouldFetch(true);

        if (mode === "add") {
          let whatsAppLink = response?.data?.whatsappLink;
          if (!whatsAppLink) {
            toast.error("There is no WhatsApp Link!");
          }
          setGeneratedLink(whatsAppLink);
        }
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="formList">
      {loading && (
        <div className="loader-overlay">
          <CustomLoader />
        </div>
      )}

      <h2>{titleName}</h2>
      <div className="inputs">
        <div className="inputs-top">
          <TextField
            className="textField"
            id="outlined-basic"
            name="Refference_Number"
            type="text"
            label="Reference Number"
            required
            variant="outlined"
            value={form.Refference_Number}
            onChange={handleChange}
            disabled={data?.Refference_Number ? txtDisabled : false}
            error={!!formErrors.Refference_Number}
            helperText={formErrors.Refference_Number}
          />
          <TextField
            className="textField"
            id="outlined-basic"
            name="Customer_Fname"
            type="text"
            label="First Name"
            required
            variant="outlined"
            value={form.Customer_Fname}
            onChange={handleChange}
            disabled={data?.Customer_Fname ? txtDisabled : false}
            error={!!formErrors.Customer_Fname}
            helperText={formErrors.Customer_Fname}
          />
          <TextField
            className="textField"
            id="outlined-basic"
            name="Customer_Lname"
            type="text"
            label="Last Name"
            required
            variant="outlined"
            value={form.Customer_Lname}
            onChange={handleChange}
            disabled={data?.Customer_Lname ? txtDisabled : false}
            error={!!formErrors.Customer_Lname}
            helperText={formErrors.Customer_Lname}
          />

          <TextField
            className="textField"
            id="outlined-basic"
            name="Contact_Number"
            type="tel"
            label="Contact Number"
            required
            variant="outlined"
            value={form.Contact_Number}
            onChange={handleChange}
            error={!!formErrors.Contact_Number}
            helperText={formErrors.Contact_Number}
          />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Arriving Date"
              value={form.Arriving_DateTime}
              name="Arriving_DateTime"
              minDate={dayjs()}
              format="YYYY-MM-DD"
              onChange={(newValue) =>
                handleDateChange(newValue, "Arriving_DateTime")
              }
              inputFormat="DD/MM/YYYY"
              renderInput={(params) => (
                <TextField
                  {...params}
                  slotProps={{
                    htmlInput: { ...params.inputProps, readOnly: true },
                  }}
                  required
                  className="textField"
                  name="dob"
                  id="outlined-basic"
                  error={!!formErrors.Arriving_DateTime}
                  helperText={formErrors.Arriving_DateTime}
                />
              )}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Depature Date"
              value={form.Depature_DateTime}
              name="Depature_DateTime"
              minDate={
                form.Arriving_DateTime
                  ? form.Arriving_DateTime.add(1, "day")
                  : null
              }
              maxDate={
                form.Arriving_DateTime
                  ? form.Arriving_DateTime.add(30, "day")
                  : null
              }
              format="YYYY-MM-DD"
              onChange={(newValue) =>
                handleDateChange(newValue, "Depature_DateTime")
              }
              inputFormat="DD/MM/YYYY"
              renderInput={(params) => (
                <TextField
                  {...params}
                  slotProps={{
                    htmlInput: { ...params.inputProps, readOnly: true },
                  }}
                  required
                  className="textField"
                  name="dob"
                  id="outlined-basic"
                  error={!!formErrors.Depature_DateTime}
                  helperText={formErrors.Depature_DateTime}
                />
              )}
            />
          </LocalizationProvider>

          <TextField
            className="textField"
            id="outlined-basic"
            name="Num_Of_Adults"
            type="number"
            label="Number of Adults"
            required
            variant="outlined"
            value={form.Num_Of_Adults}
            onChange={handleChange}
            error={!!formErrors.Num_Of_Adults}
            helperText={formErrors.Num_Of_Adults}
            slotProps={{
              input: {
                inputProps: { min: 1 },
                onKeyDown: (e) => {
                  if (e.key === "-" || e.key === "e") {
                    e.preventDefault();
                  }
                },
              },
            }}
          />
          <TextField
            className="textField"
            id="outlined-basic"
            name="Num_Of_Kids"
            type="number"
            label="Number of Kids"
            variant="outlined"
            value={form.Num_Of_Kids}
            onChange={handleChange}
            slotProps={{
              input: {
                inputProps: { min: 0 },
                onKeyDown: (e) => {
                  if (e.key === "-" || e.key === "e") {
                    e.preventDefault();
                  }
                },
              },
            }}
          />
        </div>

        <div className="inputs-bottom">
          <button
            type="button"
            onClick={onClick}
            className="cancel"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={async (event) => {
              if (!disableBtn) {
                await handleSubmit(event);
              }
            }}
            className={disableBtn ? "disabled" : "add"}
          >
            {btnName}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCustomerForm;
